import { MachineActivity } from './machinaries/machineActivity';
import { FieldActivityItem } from './fieldActivityItem';
import { Crop } from './crop';
import { Field } from './field';
import { Equipment } from './equipment';
import { User } from './user';
import { FieldActivityMix } from './fieldActivityMix';
import { CropSubUnit } from './cropSubUnit';
import { SustainabilityIndexes } from './sustainabilityIndexes';
import { EquipmentActivityTarget } from './equipmentActivityTarget';
import { TenantGeneralData } from './tenantGeneralData';
import { EquipmentsUsage } from './equipmentsUsage';

export class FieldActivity extends TenantGeneralData {
  uuid: string;
  type: any;
  workHours: number;
  workedMinutes: number;
  mixes: Array<FieldActivityMix>;
  volume: number; // SOLO Per 1. Difesa e 2. Nutrizione
  volumeUnit: string; // SOLO Per 1. Difesa e 2. Nutrizione
  techAuthorization: boolean; // SOLO Per 1. Difesa e 2. Nutrizione
  note: string;
  imgUrl: string;
  distributionMethod: string;
  batchSeed: string; // SOLO Per Semina deprecato in FieldActivity, spostato in fieldActivityMix
  verification: string;
  verificationDate: Date;
  activityDate: Date;
  dateCreated: Date;
  lastUpdated: Date;
  field: Field;
  crop: Crop;
  cropObj: Crop;
  equipments: Array<Equipment>;
  users: Array<User>;
  phenologicalStage: string;
  phenologicalStageStatus?: number;
  done: boolean;
  fieldActivityItems: Array<FieldActivityItem>;
  cropYear: number;
  externalSource: string;
  infestationLevel: string;
  interventionReason: string;
  treatmentType: string;
  startWorkingTimeHourOfDay: number;
  startWorkingTimeMinOfDay: number;
  endWorkingTimeHourOfDay: number;
  endWorkingTimeMinOfDay: number;
  machineActivity: any;
  machineActivities: Array<MachineActivity>;
  meteoBlueStatus: string;
  temperature: number;
  humidity: number;
  wind: number;
  rainLast24h: number;
  from: Date = null;
  to: Date = null;
  workingDayHours: number = null;
  plannedPeriodFrom: Date = null;
  plannedPeriodTo: Date = null;
  multipleCrops?: Array<Crop>;
  workedHectares: number;
  isAutomatched: boolean;
  numberDaysToStart?: number;
  title?: string;
  automaticActions: Array<string>;
  cropSubUnits?: Array<CropSubUnit> = [];
  closeCrops: boolean;
  sustainabilityIndexes?: Array<SustainabilityIndexes>;
  isSustainabilityIndexComputable?: boolean;
  isSustainabilityCoefficientPresent?: boolean;
  bufferZone: boolean;
  reachingThreshold: boolean;
  customType: any;
  equipmentsTargets: Array<EquipmentActivityTarget>;
  cropResiduesDestination: string;
  tillageDepth?: string;
  isBasicFeeding: boolean = false;
  equipmentsUsage: EquipmentsUsage[] = null;
  companyName?: string;
  fieldName?: string;
  employeeData?: any;
  cropName?: string;
  variety?: string;
  fieldSize?: string;
  treatmentEfficacy: string;
  analyzedSample?: string;
  analysisReportNumber?: string;
  activeSubstancesDetected?: string;
  analysisSupplierId?: number;
  attachments?: Array<string>;
  isTransSeeding?: boolean;

  constructor() {
    super();
    this.id = null;
    this.uuid = null;
    this.type = null;
    this.workHours = null;
    this.workedMinutes = null;
    this.mixes = null;
    this.volume = null; // SOLO Per 1. Difesa e 2. Nutrizione
    this.volumeUnit = null; // SOLO Per 1. Difesa e 2. Nutrizione
    this.techAuthorization = null; // SOLO Per 1. Difesa e 2. Nutrizione
    this.note = null;
    this.title = null;
    this.distributionMethod = null;
    this.batchSeed = null;
    this.imgUrl = null;
    this.verification = null;
    this.activityDate = null;
    this.verificationDate = null;
    this.dateCreated = null;
    this.lastUpdated = null;
    this.field = null;
    this.crop = null;
    this.cropObj = null;
    this.users = null;
    this.phenologicalStage = null;
    this.phenologicalStageStatus = null;
    this.done = true;
    this.fieldActivityItems = [];
    this.cropYear = null;
    this.externalSource = null;
    this.infestationLevel = null;
    this.interventionReason = null;
    this.treatmentType = null;
    this.startWorkingTimeHourOfDay = null;
    this.startWorkingTimeMinOfDay = null;
    this.endWorkingTimeHourOfDay = null;
    this.endWorkingTimeMinOfDay = null;
    this.meteoBlueStatus = null;
    this.temperature = null;
    this.humidity = null;
    this.wind = null;
    this.rainLast24h = null;
    this.from = null;
    this.to = null;
    this.workingDayHours = null;
    this.plannedPeriodFrom = null;
    this.plannedPeriodTo = null;
    this.workedHectares = null;
    this.isAutomatched = false;
    this.machineActivities = [];
    this.numberDaysToStart = null;
    this.automaticActions = null;
    this.cropSubUnits = [];
    this.closeCrops = false;
    this.sustainabilityIndexes = [];
    this.isSustainabilityIndexComputable = false;
    this.isSustainabilityCoefficientPresent = false;
    this.bufferZone = false;
    this.reachingThreshold = false;
    this.customType = null;
    this.equipmentsTargets = null;
    this.cropResiduesDestination = null;
    this.tillageDepth = null;
    this.equipmentsUsage = null;
    this.treatmentEfficacy = null;
    this.analyzedSample = null;
    this.analysisReportNumber = null;
    this.activeSubstancesDetected = null;
    this.analysisSupplierId = null;
    this.attachments = null;
    this.isTransSeeding = false;
  }
}

/*
 *********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User
import grails.databinding.BindingFormat

/**
 * Questa classe rappresenta il modello delle attività di un campo
 * Gli attributi sottostanti sono compilati o meno in base al tipo di attività
 * come elencato di seguito
 * 1. Difesa
 * 2. Nutrizione
 * 3. Irrigazione
 * 4. Operazione
 *      4.1 Arare
 *      4.2 Erpicare
 *      4.3 Seminare
 *      4.4 Potare
 *      4.5 Raccogliere
 *      4.6 Altro
 *
 */
/*
class FieldActivity {

    transient springSecurityService

    Long    companyId = -1
    string  type
    Double  workHours
    List<FieldActivityMix> mixes // SOLO Per 1. Difesa e 2. Nutrizione
    Double  volume                  // SOLO Per 1. Difesa e 2. Nutrizione
    string  volumeUnit              // SOLO Per 1. Difesa e 2. Nutrizione
    boolean techAuthorization       // SOLO Per 1. Difesa e 2. Nutrizione
    string  note
    string  imgUrl
    @BindingFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
    Date    activityDate
    Date    dateCreated
    Date    lastUpdated

    static hasMany      = [users: User, equipments: Equipment]
    static belongsTo    = [field: Field]

    static embedded = ['mixes']

    static mapping = {
        autoTimestamp true
    }

    static constraints = {
        // TODO Fix beforeInsert and beforeUpdate Events Bugs and set compoanyId nullable:false
        companyId       blank: false
        type            blank: false, nullable: false, inList: ["defending",    // 1. Difesa
                                                                "feeding",      // 2. Nutrire/Concimare
                                                                "irrigating",   // 3. Irrigazione
                                                                "tilling",      // 4.1 Arare Livello 2 di 4. Operazione
                                                                "harrowing",    // 4.2 Erpicare Livello 2 di 4. Operazione
                                                                "seeding",      // 4.3 Seminare Livello 2 di 4. Operazione (Livello 1)
                                                                "harvesting",   // 4.5 Raccogliere Livello 2 di 4. Operazione (Livello 1)
                                                                "pruning",      // 4.4 Potare Livello 2 di 4. Operazione (Livello 1)
                                                                "other"         // 4.6 Altro Livello 2 di 4. Operazione (Livello 1)
        ]
        workHours           nullable: true
        mixes               blank: false, nullable: true
        volume              blank: false, nullable: true
        volumeUnit          blank: false, nullable: true, inList: ["l_ha" // litro/ettaro
        ]
        techAuthorization       blank: false, nullable: true
        imgUrl                  blank: false, nullable: true, url: true
        note                    blank: false, nullable: true
        activityDate            blank: false, nullable: false
    }

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }

    static transients = ['springSecurityService']
}

*/
